import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import {
  buildSlotInsertDroppableId,
  SLOT_INSERT_GAP_DATA_TYPE,
  SLOT_INSERT_CARD_HALF_DATA_TYPE,
} from '../../../utils/slotDragUtils';

export function CalendarInsertGapLine({
  dateStr,
  insertIndex,
  isActive,
  zonesEnabled,
}: {
  dateStr: string;
  insertIndex: number;
  isActive: boolean;
  zonesEnabled: boolean;
}) {
  const { setNodeRef } = useDroppable({
    id: buildSlotInsertDroppableId(dateStr, insertIndex, 'gap'),
    disabled: !zonesEnabled,
    data: {
      type: SLOT_INSERT_GAP_DATA_TYPE,
      dateStr,
      insertIndex,
    },
  });
  return (
    <div
      ref={setNodeRef}
      className={`dayInfo-slot-insert-gap ${isActive ? 'dayInfo-slot-insert-gap--active' : ''}`}
      aria-hidden
    />
  );
}

export function CalendarRowInsertHalves({
  dateStr,
  rowIndex,
  zonesEnabled,
}: {
  dateStr: string;
  rowIndex: number;
  zonesEnabled: boolean;
}) {
  const top = useDroppable({
    id: buildSlotInsertDroppableId(dateStr, rowIndex, 'cardTop', rowIndex),
    disabled: !zonesEnabled,
    data: {
      type: SLOT_INSERT_CARD_HALF_DATA_TYPE,
      dateStr,
      insertIndex: rowIndex,
    },
  });
  const bottom = useDroppable({
    id: buildSlotInsertDroppableId(dateStr, rowIndex + 1, 'cardBot', rowIndex),
    disabled: !zonesEnabled,
    data: {
      type: SLOT_INSERT_CARD_HALF_DATA_TYPE,
      dateStr,
      insertIndex: rowIndex + 1,
    },
  });
  if (!zonesEnabled) return null;
  return (
    <>
      <div
        ref={top.setNodeRef}
        className="dayInfo-slot-insert-card-half dayInfo-slot-insert-card-half--top"
      />
      <div
        ref={bottom.setNodeRef}
        className="dayInfo-slot-insert-card-half dayInfo-slot-insert-card-half--bottom"
      />
    </>
  );
}
